import { IThongTinToChucThiRequest } from "../../model/request/category/IThongTinToChucThiRequest";
import { apiClient } from "../apiClient";
export const TO_CHUC_THI_ENDPOINT = "to-chuc-thi";
export const toChucThiApi = {
  SelectVm: (payload: IThongTinToChucThiRequest) =>
    apiClient.post(`${TO_CHUC_THI_ENDPOINT}/select-vm`, payload),
  SelectDotThiVm: (payload: any) =>
    apiClient.get(
      `${TO_CHUC_THI_ENDPOINT}/select-dot-thi-vm/hoc-ky/${
        payload.hoc_ky
      }/nam-hoc/${payload.nam_hoc}/mon/${payload.id_mon ?? 0}`
    ),
};
